import { render, staticRenderFns } from "./PanelChangelog.vue?vue&type=template&id=93e784ea&scoped=true&"
import script from "./PanelChangelog.vue?vue&type=script&lang=js&"
export * from "./PanelChangelog.vue?vue&type=script&lang=js&"
import style0 from "./PanelChangelog.vue?vue&type=style&index=0&id=93e784ea&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93e784ea",
  null
  
)

export default component.exports